<template>
    <div class="activityRules">
        <div class="awardRules rules">
            <div class="rules-title">
                <h4>活动规则</h4>
            </div>
            <div class="awardRules-main">
                <template v-for="(i, n) in time">
                    <h5 :key="'h5' + n" v-show="i.title">{{ i.title }}</h5>
                    <p :key="'p' + n" class="awardRules-text" v-html="i.text"></p>
                </template>
                <!-- <template v-for="(i, n) in awardRulesText"> -->
                    <h5 v-show="awardRulesText.title">{{ awardRulesText.title }}</h5>
                    <div class="t-text" v-for="(item,index) in awardRulesText.text" :key="index">
                        <h5><i>{{ index + 1 }}.</i>{{item.tit}}</h5>
                        <span>{{ item.txt }}</span>
                    </div>
                <!-- </template> -->

                <h5>活动须知</h5>
                <ul class="rules-ul">
                    <li v-for="(i, index) in awardRules" :key="index">
                        <i>{{ index + 1 }}.</i>
                        <p v-html="i"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "activityRules",
    data() {
        return {
            time:[
                {
                    title: "活动时间",
                    text: "2024年12月27日~2025年1月9日"
                },
            ],
            awardRulesText:
            {
                    title: "参与方式及奖励",
                    text: [
                        {
                            tit:'详细回顾：',
                            txt:'在圈子话题#我的2024年度总结#发帖、投稿，回顾您的2024年游戏年度总结，由编辑从投稿中筛选最优的5篇投稿得奖，奖品为北通阿修罗3S手柄；'
                        },
                        {
                            tit:'简要回顾：',
                            txt:'通过游民星空app生成我的年度回顾报告（任意平台均可），回复本贴并带上报告截图即可参与抽奖，奖品为北通宙斯手柄精英版；'
                        }
                    ]
            },
            
            awardRules: [
                "参与话题投稿活动内容要求原创，不得洗稿、抄袭，不符合要求的文章经发现后将被取消奖励，且该作者的其他作品同样不得参与活动；",
                "参与话题投稿活动，会根据文章质量（排版、逻辑、专业度等）、受众、热度等综合考量评判，决定是否推荐到首页。推荐使用PC网页版圈子高级编辑器；",
                "发文需遵守《游民圈子总版规》【网页链接】，违规行为将被删帖/封号等处罚；",
                "在回复中晒出的年度游戏报告需为自己的专属年度游戏报告，不可盗用、冒用其他用户的年度报告，如有发现，将取消其活动资格；",
                "禁止刷帖行为，如有发现，将取消其获奖资格；",
                "抽奖方式为使用随机生成数，活动结束后将在本帖进行开奖，如抽到不合规用户则重新抽取直到回帖合规；",
                "获奖名单在活动结束后由官方在活动帖内进行公布，并通过站内信的方式告知中奖用户，请各位游民用户及时查看；",
                "本次活动奖品无法兑换其他道具或现金；",
            ]
        };
    },
};
</script>
<style lang="scss" scoped>
.ruleA {
      color: #f53f3f;
  }
.activityRules {
    width: 391px;
    .rules {
        padding: 0 25px 20px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 10px;
        &:last-of-type {
            margin: 0;
        }
        .rules-title {
            position: relative;
            margin-bottom: 10px;
            height: 58px;
            border-bottom: 1px solid #eee;
            overflow: visible;
            h4 {
                line-height: 58px;
                color: #444;
                font-size: 18px;
            }
            i {
                display: block;
                width: 147px;
                height: 23px;
                position: absolute;
                right: -5px;
                top: 18px;
                background-image: url(//image.gamersky.com/webimg13/zhuanti/wqj2020/pc/isyou.png);
                background-repeat: no-repeat;
            }
        }
        .rules-ul {
            width: 100%;
            overflow: hidden;
            li {
                margin-bottom: 5px;
                padding-left: 22px;
                position: relative;
                overflow: hidden;
                i {
                    line-height: 24px;
                    color: #333;
                    font-size: 14px;
                    font-weight: 700;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                p {
                    line-height: 24px;
                    color: #333;
                    font-size: 14px;
                    text-align: justify;
                }
                &:first-of-type {
                    p {
                        font-weight: 700;
                    }
                }
            }
          
        }
                
        .awardRules-main {
            .awardRules-text {
                line-height: 24px;
                color: #333;
                font-size: 14px;
                margin-top: 5px;
                &.ffc555 {
                    color: #ffc555;
                    margin-top: 10px;
                    font-weight: bold;
                }
            }
            h5 {
                line-height: 30px;
                color: #333;
                font-size: 14px;
            }
            .rules-ul {
                li {
                    &:first-of-type {
                        p {
                            font-weight: normal;
                        }
                    }
                }
            }

            .t-text{
                margin-bottom: 5px;
                font-size: 14px;
                h5{
                    display: inline-block;
                }
            }
        }
        .award-btn {
            margin: 0 auto 15px;
            display: block;
            width: 300px;
            height: 42px;
            line-height: 42px;
            color: #433e47;
            font-size: 18px;
            text-align: center;
            border-radius: 20px;
            background: url("//image.gamersky.com/webimg13/zhuanti/wqj2020/pc/cjbtn.png") no-repeat;
            box-shadow: 0 20px 24px 0 rgba(158, 111, 20, 0.2);
            &:hover {
                background-position-y: -42px;
            }
            &.stop {
                color: #aaa;
                background: #f2f2f3;
                border: 1px solid #cecece;
                cursor: default;
            }
        }
        .lotteryCount {
            text-align: center;
            font-size: 14px;
            color: #aaa;
        }
    }
}
</style>
